import React from 'react'
import { Link } from 'react-router-dom'
import { RichText as PrismicRichText } from 'prismic-reactjs'
import { OneColumnSlice } from 'modules/prismic'
import { Wrapper } from './styled'

export const OneColumn = ({ primary }: OneColumnSlice) => {
  const { content, text_alignment: textAlignment, button_label: buttonLabel, button_url: buttonUrl, button_size: buttonSize } = primary

  return (
    <Wrapper textAlignment={textAlignment}>
      {PrismicRichText.render(content)}
      {buttonLabel && buttonUrl && (
        <Link to={buttonUrl} className={`btn ${buttonSize === 'large' ? 'btn-lg' : undefined}`}>
          {buttonLabel}
        </Link>
      )}
    </Wrapper>
  )
}
